export default __webpack_public_path__ + "static/media/LaptopStand_Blue.d2446b9c.png";